import { NavLink } from "react-router";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function NotFound(): JSX.Element {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] bg-gray-50 text-center px-6">
      {loading ? (
        <motion.p
          className="text-8xl font-extrabold text-indigo-600 mb-4"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Loading...
        </motion.p>
      ) : (
        <>
          <motion.h1
            className="text-8xl font-extrabold text-indigo-600 mb-4"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            404
          </motion.h1>

          <motion.h2
            className="text-3xl font-bold text-gray-900 mb-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            Oops! Page Not Found
          </motion.h2>

          <motion.p
            className="text-gray-600 mb-8 max-w-md"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            The page you’re looking for doesn’t exist or has been moved. Don’t
            worry — let’s get you back on track.
          </motion.p>

          <motion.div
            className="flex flex-wrap justify-center gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.7 }}
          >
            <NavLink
              to="/"
              className="rounded-xl bg-indigo-600 px-6 py-3 text-white font-semibold shadow-md hover:bg-indigo-700"
            >
              Go Home
            </NavLink>
            <NavLink
              to="/contact"
              className="rounded-xl bg-white px-6 py-3 text-indigo-600 font-semibold shadow-md hover:bg-indigo-50"
            >
              Contact Support
            </NavLink>
          </motion.div>

          <motion.img
            src="/images/404-illustration.svg"
            alt="Not found illustration"
            className="mt-12 w-full max-w-md mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.8 }}
          />
        </>
      )}
    </div>
  );
}
